import { store } from "@betacrew/jars-flux";
import { PAGE_STATE } from '../../../constants/constants';

export const componentKey = "FORMS/REVIEW_REJECTED_FORMS/STATE_PAYROLL_FORMS"

const { actions } = store.reducerManager.add({
    key: componentKey,
    addedReducers: {
        setLoadingState: (state, action) => {
            state.loadingState = action.payload;
        },
        setStateList: (state, action) => {
            state.stateList = action.payload;
        },
        setSelectedState: (state, action) => {
            state.selectedState = action.payload;
        },
        setFormList: (state, action) => {
            state.formList = action.payload;
        },
        setSelectedForm: (state, action) => {
            state.selectedForm = action.payload;
        },
        setTaxYearList: (state, action) => {
            state.taxYearList = action.payload;
        },
        setSelectedTaxYear: (state, action) => {
            state.selectedTaxYear = action.payload;
        },
        setPayersList: (state, action) => {
            state.payersList = action.payload;
        },
        setSelectedPayer: (state, action) => {
            state.selectedPayer = action.payload;
        },
        setRejectedStatePayrollFormsGrid: (state, action) => {
            state.rejectedStatePayrollFormsGrid = action.payload;
        },
        setSelectedRejectedStatePayrollForms: (state, action) => {
            state.selectedRejectedStatePayrollForms = action.payload;
        },
        setPaginationState: (state, action) => {
            state.paginationState = { ...state.paginationState, ...action.payload }
        },
        setFormListLoadingState: (state, action) => {
            state.formListLoadingState = action.payload;
        },
        setPayerListLoadingState: (state, action) => {
            state.payerListLoadingState = action.payload;
        },
        setGridDataLoadingState: (state, action) => {
            state.gridDataLoadingState = action.payload;
        },

        setDeleteStatePayrollRejectedFormModal: (state, action) => {
            state.deleteStatePayrollRejectedFormModal = action.payload;
        },

        setClickedFormDetails: (state, action) => {
            state.clickedFormDetails = action.payload;
        },
        
        setReloadReviewRejectedGridData: (state, action) => {
            state.reloadReviewRejectedGridData = action.payload;
        },

        setUrlFormIdParam: (state, action) => {

            state.urlFormIdParam = action.payload;
        },

        setUrlPayerIdParam: (state, action) => {
            state.urlPayerIdParam = action.payload;
        }

    },
    initialReducerState: {
        loadingState: { state: PAGE_STATE.PAGE_READY, message: "" },
        formListLoadingState: { state: PAGE_STATE.PAGE_READY, message: "" },
        payerListLoadingState: { state: PAGE_STATE.PAGE_READY, message: "" },
        gridDataLoadingState: { state: PAGE_STATE.PAGE_READY, message: "" },

        stateList: [],
        selectedState: { label: "", value: "" },

        formList: [],
        selectedForm: { label: "", value: "" },

        taxYearList: [],
        selectedTaxYear: { label: "", value: "" },

        payerList: [],
        selectedPayer: { label: "", value: "" },

        rejectedStatePayrollFormsGrid: [],
        selectedRejectedStatePayrollForms: [],

        paginationState: {
            PageNumber: 1,
            PageSize: 5,
            FilterText: "",
            IsDesc: true,
            IdNumber: "",
            Skip: 0,
            total: 5,
        },

        deleteStatePayrollRejectedFormModal: false,

        clickedFormDetails: {},

        reloadReviewRejectedGridData: false,

        urlFormIdParam: null,
        urlPayerIdParam: null,

    }
})

export const { setLoadingState, setStateList, setSelectedState, setFormList, setSelectedForm, setTaxYearList, setSelectedTaxYear, setPayersList, setSelectedPayer, setRejectedStatePayrollFormsGrid, setSelectedRejectedStatePayrollForms, setPaginationState, setFormListLoadingState, setPayerListLoadingState, setGridDataLoadingState, setDeleteStatePayrollRejectedFormModal, setClickedFormDetails, setReloadReviewRejectedGridData, setUrlFormIdParam, setUrlPayerIdParam  } = actions;